module.exports = __webpack_public_path__ + "static/media/casabela-3.f2b319b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/casabela-3.png
// module id = 163
// module chunks = 1